(() => {
  if (window.bucketGolfClubUpsellDiscount) return;
  window.bucketGolfClubUpsellDiscount = true;

  const clubHandles = new Set(['new-red-bucketgolf-club', 'limited-edition-gold-bucketgolf-club']);
  let revision = 0;
  let refreshTimer;

  function updatePrice(card) {
    if (!card) return;
    const offer = card.querySelector('[data-club-upsell-discount]');
    const price = card.querySelector('[data-cart-upsell-price], [data-pdp-upsell-price]');
    if (!offer || !price) return;
    const basePrice = Number(price.dataset.basePrice);
    const discount = Number(offer.dataset.discountPercent) || 0;
    if (!Number.isFinite(basePrice)) return;
    const format = cents => {
      if (price.dataset.priceCurrency) {
        return new Intl.NumberFormat(price.dataset.priceLocale || document.documentElement.lang || 'en', {
          style: 'currency', currency: price.dataset.priceCurrency
        }).format(cents / 100);
      }
      if (window.theme && theme.Currency && theme.settings) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
      }).format(cents / 100);
    };
    if (discount > 0) {
      const discountedPrice = Math.round(basePrice * (100 - discount) / 100);
      price.innerHTML = `<s class="club-upsell-discount__compare-price">${format(basePrice)}</s> <span class="club-upsell-discount__sale-price">${format(discountedPrice)}</span>`;
    } else {
      price.innerHTML = format(basePrice);
    }
  }

  window.bucketGolfClubUpsellPrice = updatePrice;

  function render(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const count = cart.items.reduce((total, item) => {
      const isClub = clubHandles.has(item.handle);
      const isGift = item.properties && item.properties._bundle_role === 'gift';
      return total + (isClub && !isGift ? item.quantity : 0);
    }, 0);
    const discount = count >= 4 ? 15 : 10;
    document.querySelectorAll('[data-club-upsell-discount]').forEach(element => {
      element.hidden = count < 2;
      element.dataset.discountPercent = count >= 2 ? discount : 0;
      element.querySelector('[data-club-upsell-badge]').textContent = element.dataset.badgeTemplate.replace('__DISCOUNT__', discount);
      const message = element.querySelector('[data-club-upsell-message]');
      message.hidden = count !== 2 && count !== 4;
      message.textContent = element.dataset.messageTemplate.replace('__DISCOUNT__', discount);
      updatePrice(element.closest('.cart-upsells__card'));
    });
  }

  async function refresh() {
    const currentRevision = ++revision;
    try {
      const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (currentRevision === revision) render(cart);
    } catch (_) {}
  }

  function scheduleRefresh(event) {
    if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) {
      ++revision;
      render(event.detail.cart);
    }
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 80);
  }

  ['ajaxProduct:added', 'cart:updated', 'cart:rebuilt', 'drawerOpen.cart'].forEach(name => {
    document.addEventListener(name, scheduleRefresh);
  });
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.querySelectorAll('[data-club-upsell-discount]').forEach(element => {
    updatePrice(element.closest('.cart-upsells__card'));
  });
  refresh();
})();
